import draggable from 'vuedraggable';

export default defineNuxtPlugin((nuxtApp): void => {
  nuxtApp.vueApp.component('Draggable', draggable);
});
